import React, { useState, useEffect } from 'react';
import intl from 'react-intl-universal';
import { useNavigate } from 'react-router-dom';

import { RightOutline, DownOutline } from 'antd-mobile-icons'
import { Image } from 'antd-mobile';
import { getScopeParam } from '../../../utils/session/store'
import { formatJSON, stripHtmlTags, replaceCDNDomain } from '../../../utils';

import CouponType from './CouponType';
import dayjs from 'dayjs';
import styles from './index.module.less';
import { getReachCanUseText, getDiscountDisplay, getExpiredText } from '../../../utils/coupon';


const CouponList = ({ list = [], relateArea = '' }) => {
  const navigate = useNavigate()
  const scopeParam = getScopeParam()

  const [couponList, setCouponList] = useState(list)


  const setShowRule = (coupon) => {
    coupon.showRule = !coupon.showRule
    setCouponList([...couponList])
  }

  useEffect(() => {
    setCouponList(list)
  }, [list])

  return (
    <div className={styles.myCouponContainer}>
      {couponList.map((coupon, index) => {
        const { useRule, couponRuleSourceParam4 } = coupon;
        const ruleStr = (formatJSON(useRule)?.briefDesc || '');

        // 有效期
        const validDate = getExpiredText(coupon);

        let isOffline = false
        if (couponRuleSourceParam4) {
          const ruleObj = formatJSON(couponRuleSourceParam4) || {};
          isOffline = ruleObj.couponUseWay === 2;
        }


        return (
          <div key={index} className={`${styles.couponCard} ${coupon.couponState === 3 ? styles.couponExpired : ''}`}>
            {/* 顶部金额区 */}
            <div className={styles.couponHeader}>
              <div className={styles.couponAmount}>
                {/* <span className={styles.amountSymbol}>￥</span> */}
                {
                  coupon.couponType !== 3 && (<span className={styles.amountValue}>{getDiscountDisplay(coupon)}</span>)
                }

                <span className={styles.amountLimit}>{getReachCanUseText(coupon)}</span>
              </div>
              <div className={styles.couponTag}><CouponType couponType={coupon.couponType} /></div>
            </div>
            {/* 主体信息区 */}
            <div className={styles.couponBody}>
              <div className={styles.couponTitle}>{coupon.couponName}</div>
              <div className={`${styles.couponRuleTitle} jm-flex`} onClick={() => {
                setShowRule(coupon)
              }}>
                <div className='jm-flex-item'>{intl.get('h_detail').d('详情')}</div>
                <div>{coupon.showRule ? <DownOutline fontSize={14} /> : <RightOutline fontSize={14} />}</div>
              </div>
              <div className={styles.useRuleBox} style={{ display: coupon.showRule ? 'block' : 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 5 }}>
                  <Image src={replaceCDNDomain(coupon.couponQrcode)} style={{ width: '50%', height: 'auto' }} />
                </div>
                <div className='text-center'><h2>{coupon.couponNum}</h2></div>
                <div
                  className={styles.couponDesc}
                  dangerouslySetInnerHTML={{ __html: ruleStr }}
                  style={{ lineHeight: 1.3 }}>
                </div>
                <div className={styles.couponValid}>{intl.get('valid_period').d('有效期')}:{validDate}</div>
              </div>


              {/* <div className={styles.couponLimit}>{coupon.limitDesc || <>&nbsp;</>}</div> */}
              {
                coupon.couponState === 3 && (<div className={styles.expiredBlock}>{intl.get('expired').d('已过期')}</div>)
              }
            </div>
            {/* 底部操作区 */}
            <div className={styles.couponFooter}>
              <div className={styles.merchant}>{coupon.storeList?.map(item => item.name).join(',')}</div>
              {
                coupon.couponState === 1 && !isOffline && (
                  <button className={styles.couponBtn}
                    onClick={() => {
                      const { storeList } = coupon
                      if (storeList.length > 0) {
                        // console.log(storeList)
                        const store = storeList[0]
                        const text = `areaid=${relateArea || scopeParam.areaId}&storeid=${store.storeId}&partnerid=${store.partnerId}&hotel=${store.name}`
                        if (store.type === 3) { //to spa
                          navigate(`/spa?${text}`)
                        } else {
                          navigate(`/carte?${text}`)
                        }

                      }
                    }}>
                    {intl.get('use_now').d('立即使用')}
                  </button>)
              }
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CouponList;